<div class="avatar">
  @if (!isCandidateDataVisible()) {
    <rt-avatar
      [shape]="'oval'"
      size="base"
      type="icon"
      iconName="visibility-off"
      customIconBackgroundColor="colorAvatarSteelLighter"
      customIconColor="colorIconDisabled"
      (click)="avatarClick.emit()"
    ></rt-avatar>
  } @else {
    <rt-avatar
      [type]="candidate().hasAvatar ? 'image' : 'initials'"
      [initials]="candidate().initials"
      shape="oval"
      size="base"
      [imageSrc]="candidate().photoThumbUrl"
      [isColorized]="true"
      (click)="avatarClick.emit()"
    >
    </rt-avatar>
  }
</div>

<div class="description">
  <div class="name-rating" layout>
    <div (click)="candidateClick.emit()" class="name">
      <rt-heading variant="heading large align-center">
        {{ candidate().name }}
      </rt-heading>
    </div>
  </div>

  @if (firstPlacement(); as placement) {
    <div class="placement">
      @if (placement.offer) {
        <rt-offer-status-indicator [offerStatus]="placement.offer" margin-right-small-xx />
      }
      @if (placement.offer) {
        <span [routerLink]="urlCommands()" class="offer">
          {{ placement.offer.title }}
        </span>
      }
      @if (placement.stage && !placement.disqualifyReason) {
        <span [routerLink]="urlCommands()" class="stage">
          /&nbsp;
          <span class="stage--name">{{ placement.stage.name }}</span>
        </span>
      }
      @if (placement.disqualifyReason) {
        <span [routerLink]="urlCommands()" class="disqualify-reason">
          /&nbsp;<rt-icon size="small-x" name="block"> </rt-icon> {{ placement.disqualifyReason }}
        </span>
      }
    </div>
  }
</div>
